import { Box, CardContent, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from "@material-ui/core"
import CardComponent from "../../../../components/Card"
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Get, Post } from "../../../../actions";
import { Get_SystemSetting_URL } from "../../../../constants/apiUrls";
import { useEffect, useState } from "react";
import { getTranslation } from "../../../../heplers/translationHelper";
import { useSnackbar } from "notistack";

export const Reservation=()=>{
  const { enqueueSnackbar } = useSnackbar();
  const [systemSetting, setSystemSetting] = useState({});

  useEffect(() => {
    getSystemSetting();
  }, []);

  const getSystemSetting = () => {
    Get(
      {},
      Get_SystemSetting_URL,
      null,
      (res) => {
        setSystemSetting(res?.data);
      },
      (err) => {
        enqueueSnackbar(
          err.data
            ? getTranslation(err.data, err.data, err.data)
            : getTranslation(
                "Something went wrong. Please contact with admin.",
                "Something went wrong. Please contact with admin.",
                "Something went wrong. Please contact with admin."
              ),
          {
            variant: "error",
          }
        );
      }
    );
  };
  const handleChange = (e, value) => {
    if (value!=null) {
      Post(
        {
          enableMultipleBookings: value,
        },
        "System/ChangeMultiBookingStatus",
        null,
        (resp) => {
          enqueueSnackbar(getTranslation("Status changed"), { variant: "success" });
    getSystemSetting();

        },
        (error) => {}
      );
    }
  };
  return (
    <CardComponent title={getTranslation("Reservation Settings", "Reservation Settings", "Reservation Settings")}>
      <CardContent>
        <Grid container>
          <Grid item sm={8}>
            <Typography component="legend" variant="body2">
            {getTranslation("Can double booking be allowed manually?")}
          </Typography>
          </Grid>
          <Grid item sm={4}>
            <ToggleButtonGroup value={systemSetting.enableMultipleBookings} exclusive onChange={handleChange}>
              <ToggleButton value={true}> {getTranslation("Allowed", "Allowed", "Allowed")}</ToggleButton>
              <ToggleButton value={false}>{getTranslation("Not Allowed", "Not Allowed", "Not Allowed")}</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid item sm={12}>
            <Typography variant="body2">
            {getTranslation("Double bookings signify that two (or more) reservations can be possible on the same table(s) at the same time. Tablemanager will never do this automatically. Only when making manual reservations can you choose to allow double bookings. This offers more flexibility. However, by default, this avoids double bookings.")}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </CardComponent>
  );
}